import React, { createContext, useContext } from 'react'

export const StateContext = createContext()

export const StateProvider = ({initialState, children}) => (
  <StateContext.Provider value={initialState}>
    { children }
  </StateContext.Provider>
)

export const useStoreState = () => useContext(StateContext)
